import { PartnersApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const partnersApi = new PartnersApi(config);

export const partnersRequestInit = { credentials: 'include' as const };
